import AdminIcon from '../assets/icons/nav-item-admin.svg';
import ConfigurationIcon from '../assets/icons/nav-item-configuration.svg';
import ContentIcon from '../assets/icons/nav-item-content.svg';
import CurtinLifeIcon from '../assets/icons/nav-item-curtin-life.svg';
import DefaultIcon from '../assets/icons/nav-item-default.svg';
import GetStartedIcon from '../assets/icons/nav-item-get-started.svg';
import HomeIcon from '../assets/icons/nav-item-home.svg';
import StudentLookupIcon from '../assets/icons/nav-item-lookup.svg';
import PreviewIcon from '../assets/icons/nav-item-preview.svg';
import StudiesIcon from '../assets/icons/nav-item-studies.svg';
import SupportIcon from '../assets/icons/nav-item-support.svg';
const menuIconNames = {
    'Home': HomeIcon.id,
    'Studies': StudiesIcon.id,
    'Curtin Life': CurtinLifeIcon.id,
    'Support': SupportIcon.id,
    'Preview': PreviewIcon.id,
    'Content': ContentIcon.id,
    'Configuration': ConfigurationIcon.id,
    'Admin': AdminIcon.id,
    'Student Lookup': StudentLookupIcon.id,
    'Get Started': GetStartedIcon.id
};
export function getMenuItemIconName(menuItem) {
    return getIconName(menuItem.label, menuItem.iconName);
}
function getIconName(itemName, iconName) {
    if (!iconName || typeof iconName == 'undefined')
        return iconName;
    if (!!iconName && typeof iconName === 'object')
        return iconName.then(p => getIconName(itemName, p));
    if (iconName.startsWith('#'))
        return iconName.substring(1);
    iconName = iconName.trim();
    const isReference = iconName.startsWith('{') && iconName.endsWith('}');
    if (iconName !== 'auto' && isReference == false)
        return iconName;
    if (isReference)
        itemName = iconName.substring(1, iconName.length - 1);
    return menuIconNames[itemName]
        ?? DefaultIcon.id;
}
